// components
import { RForm } from '@/components/reusable_components/next'
import { beforeRouteEnter } from '@/mixins/reusable_mixins/permissions'
import translatorService from '@/services/translator'

// models
import DispatchRequestService from '@/services/api/Warehouse/WhDispatchRequest'
import DispatchRequestModel from '@/models/Warehouse/WhDispatchRequest'
import DispatchRequestFields from '@/views/Warehouse/WhDispatchRequest/receive/fields'

// view
export default {
    name: 'dispatch-requests-update',
    components: {
        RForm,
    },
    computed: {

        /**
         * Determines if editable.
         *
         * @return     {boolean}  True if editable, False otherwise.
         */
        isEditable() {
            return (
                this.formData.can_receive && this.$can('EDIT_DISPATCH_REQUEST')
            )
        },

        /**
         * { function_description }
         *
         * @return     {Object}  { description_of_the_return_value }
         */
        fieldsProps() {
            return {
                g_branch_office_id: 1,
                readonly: !this.formData.can_receive,
            }
        },

        /**
         * { function_description }
         *
         * @return     {Object}  { description_of_the_return_value }
         */
        formProps() {
            return {
                editable: this.isEditable,
                fields: DispatchRequestFields(this.fieldsProps),
                loading: this.formLoading,
                noSubmit: !this.formData.can_receive,
                switchEdit: this.isEditable,
                title: this.title,
            }
        },

        /**
         *
         */
        title() {
            let title = `Solicitud de despacho #${this.$route.params.id}`
            return title
        },
    },
    data() {
        return {
            busy: false,
            formData: {},
            formLoading: false,
        }
    },
    methods: {

        /**
         * Fetches a form data.
         *
         * @return     {<type>}  The form data.
         */
        fetchFormData() {
            return DispatchRequestModel.modeler()
                .find(this.$route.params.id)
                .then(this.setFormData)
        },

        /**
         * { function_description }
         */
        redirect() {
            this.$router.push({ 
                name: this.$route.query.from || 'dispatch-request-list' 
            })
        },

        /**
         * Resets the object.
         */
        reset() {
            this.setFormLoading(true)
                .then(this.fetchFormData)
                .then(this.setFormLoading)
        },

        /**
         * Sets the form data.
         *
         * @param      {<type>}   model   The model
         * @return     {Promise}  { description_of_the_return_value }
         */
        async setFormData(model) {
            this.formData = model.reset()
        },

        /**
         * Sets the form loading.
         *
         * @param      {boolean}  [value=false]  The value
         */
        async setFormLoading(value = false) {
            this.formLoading = value
        },

        /**
         * Catch a error of a dispatch request promise.
         *
         * @param      {Object}  [error={}]  The error.
         */
        showError(error = {}) {
            this.showErrorSnackbar(translatorService(DispatchRequestModel,error.response.data))
        },

        /**
         * Shows the success update.
         */
        showSuccessReceive() {
            this.showSuccessSnackbar('Solicitud de despacho recepcionada exitosamente.')
        },

        /**
         * { function_description }
         *
         * @return     {<type>}  { description_of_the_return_value }
         */
        submitReceive() {
            return this.toWait(true)
                .then(this.toReceive)
                .then(this.showSuccessReceive)
                .then(this.reset)
                .catch(this.showError)
                .then(this.toWait)
        },

        /**
         * Returns a reception representation of the object.
         *
         * @return     {<type>}  Reception representation of the object.
         */
        toReceive() {
            //
            let data = this.formData.toReceive()
            //
            data.wh_detail_dispatch_request = this.$refs.form.getInput('wh_selected_dispatch_requests').selected.map(this.formData.mapReceiveDetail)
            console.log(this.$refs.form.getInput('wh_selected_dispatch_requests'))
            console.log(data.wh_detail_dispatch_request)
            //
            return this
                .formData
                .receive()
                .sync(data)
        },
        /**
         * { function_description }
         *
         * @param      {boolean}  [value=false]  The value
         * @return     {<type>}   { description_of_the_return_value }
         */
        toWait(value = false) {
            return this.$refs.form.setWait(value)
        },
    },
    beforeRouteEnter: beforeRouteEnter('VIEW_DETAIL_DISPATCH_REQUEST'),
    beforeMount() {
        this.setTitle(this.title)
    },
    mounted() {
        this.reset()
    },
}
